import { render } from "./YesterdayStats.vue?vue&type=template&id=12767888&scoped=true"
import script from "./YesterdayStats.vue?vue&type=script&lang=js"
export * from "./YesterdayStats.vue?vue&type=script&lang=js"

import "./YesterdayStats.vue?vue&type=style&index=0&id=12767888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12767888"]])

export default __exports__